module.exports = __webpack_public_path__ + "kiss.87671e45.png";